// G-1i / V103-8-3: Cloudflare account remediation variants for the shared
// vendor-neutral checks this kind emits (merged into REMEDIATION_HINTS through
// the `cloudflare` manifest's `outputs.hints`). Drafted 2026-10-07, pending
// owner review; steps match adapters/cloudflare-account-collector.ts pass rules.
export const CLOUDFLARE_HINTS = {
    idp_mfa_enforced: {
        steps: [
            'In the Cloudflare dashboard open Manage Account > Configurations and turn on "Enforce two-factor authentication" for all members.',
            'Or sign members in only through your SSO identity provider (Dashboard SSO), which applies its own MFA.',
            'Members who have not enrolled are listed by hashed id in the check details; ask them to enroll, then re-run the connector.',
        ],
        draft: true,
        doc_url: 'https://developers.cloudflare.com/fundamentals/user-profiles/2fa/',
    },
    cloud_service_credentials_rotated: {
        steps: [
            'In Manage Account > Account API Tokens, find active tokens with Edit or Write permissions issued more than 90 days ago.',
            'Roll each token (or create a replacement), update the service that uses it, then delete the old token.',
            'Give automation tokens an expiry (TTL) and IP filtering so long-lived write tokens do not accumulate.',
        ],
        draft: true,
        doc_url: 'https://developers.cloudflare.com/fundamentals/api/how-to/roll-token/',
    },
    saas_audit_logging_enabled: {
        steps: [
            'Cloudflare always records account audit logs and keeps them 18 months; this check fails only when the connector cannot read them.',
            'Give the connector token Account Settings Read for this account, then re-run it.',
            'Send audit logs to your SIEM with Logpush if you need to keep them longer than 18 months.',
        ],
        draft: true,
        doc_url: 'https://developers.cloudflare.com/fundamentals/account/account-security/review-audit-logs/',
    },
    cloud_asset_inventory_recording: {
        steps: [
            'The check passes when the connector can count Workers scripts, custom domains and routes in the account.',
            'Give the connector token Workers Scripts Read and Workers Routes Read, then re-run it.',
            'Record the counted Workers in your system boundary inventory.',
        ],
        draft: true,
        doc_url: 'https://developers.cloudflare.com/workers/configuration/routing/',
    },
};
//# sourceMappingURL=cloudflare.js.map